import { toast } from 'sonner';

/**
 * The dead toast channel (2026-08-19 remediation Slice C, Task 2). Before
 * this, `<Toaster position="bottom-right" />` was mounted at `main.tsx` but
 * `toast()` had zero call sites app-wide — every mutation succeeded or
 * failed in complete silence. These two helpers are the single entry point
 * every mutation hook's `onSuccess`/`onError` calls, so every confirmation
 * and failure gets the same shape and behaviour.
 *
 * This is the *visual* channel only — it supplements, and never replaces,
 * Slice B's `LiveRegion` (`components/a11y/LiveRegion.tsx`, the *assistive*
 * channel) or any inline error text a component already renders.
 */

/** DESIGN.md: toasts are bottom-right, 4s, success/error/info. */
export function notifySuccess(message: string): void {
  toast.success(message);
}

/**
 * Server errors arrive as `{ error }` in Romanian (server convention), so a
 * real Error's message is already user-facing and is preferred. Anything
 * else — a thrown non-Error, or a blank message — falls back rather than
 * showing the user an empty or English toast.
 */
export function notifyError(error: unknown, fallback: string): void {
  const message = error instanceof Error ? error.message.trim() : '';
  toast.error(message.length > 0 ? message : fallback);
}
